<div class="bread-crumb" >
  <mat-chip-list>
    <mat-chip *ngFor="let route of currentRouteList; last as isLast">
      <a    *ngIf="!isLast" (click)="navigateTo(currentRoute.slice(0, currentRoute.indexOf(route) + route.length));">{{ route | i18next }}</a>
      <span *ngIf="isLast">{{ route | i18next }}</span>
    </mat-chip>
  </mat-chip-list>
</div>
